/** Optional Apollo persistence must never hold the application's first render. */
export class BoundedApolloStorage {
    constructor(storage, { timeoutMs = 2000, warn = () => console.warn('Apollo persistent cache unavailable; using memory cache.') } = {}) {
        this.storage = storage;
        this.timeoutMs = timeoutMs;
        this.warn = warn;
        this.disabled = false;
    }

    disable() {
        if (this.disabled) return;
        this.disabled = true;
        this.warn();
    }

    call(method, ...args) {
        return new Promise((resolve, reject) => {
            const timer = setTimeout(() => reject(new Error('Apollo persistence timeout')), this.timeoutMs);
            Promise.resolve().then(() => this.storage[method](...args)).then(
                value => { clearTimeout(timer); resolve(value); },
                error => { clearTimeout(timer); reject(error); }
            );
        });
    }

    async getItem(key) {
        if (this.disabled) return null;
        try { return await this.call('getItem', key); }
        catch (error) { this.disable(); return null; }
    }

    async setItem(key, value) {
        if (this.disabled) return;
        try { await this.call('setItem', key, value); }
        catch (error) { this.disable(); }
    }

    async removeItem(key) {
        if (this.disabled) return;
        try { await this.call('removeItem', key); }
        catch (error) { this.disable(); }
    }
}
